import type { enStory } from './en.story';

export const esStory: typeof enStory = {
  story: {
    ui: {
      chapter: (n: number) => `Capítulo ${n}`,
      locked: 'Hoy no está disponible',
      progress: (done: number, total: number) => `${done}/${total}`,
      offers: 'tiene algo para ti',
      talk: 'Habla con',
    },
    items: {
      postcard: { name: 'Postal de Taipéi', desc: 'Para la abuela Lee. Tres distintas forman la colección.' },
      pineappleCake: { name: 'Pasteles de piña', desc: 'Una caja de 鳳梨酥 de Taipéi, para mamá.' },
      mochi: { name: 'Mochi de Hualien', desc: 'Una caja de 麻糬 blanditos para Bo. ¡Cómetelos hoy!' },
      pebble: { name: 'Guijarro de Qixingtan', desc: 'Redondo y gris, pulido por el Pacífico. Para Rain.' },
      photo: { name: 'Foto desde la Montaña del Elefante', desc: 'Tú y el Taipéi 101. Para Emma.' },
    },
    chapters: {
      school: { title: 'Primer día de vuelta', hint: 'Viernes en el insti: amigos, profes y un conserje que se saltó el desayuno.' },
      town: { title: 'Fin de semana en el barrio', hint: 'Sábado y domingo por el pueblo: gatitos perdidos, cometas y tréboles de la suerte.' },
      taipei: { title: 'Postales de Taipéi', hint: 'Coge el tren en la estación. La ciudad tiene encargos para ti en cada distrito.' },
      hualien: { title: 'Viento del Pacífico', hint: 'El tren hacia el este llega a Hualien: desfiladeros de mármol, playas de guijarros y mochi pegajoso.' },
    },
    quests: {
      postcards: {
        offer: 'De joven nunca pude ver la gran ciudad. ¿Me traerías postales de Taipéi? Una de la estación, otra del templo de Longshan y otra de la Plaza de la Libertad.',
        accept: '¡Te traeré tres postales!',
        collect: {
          guide: 'Una postal de la Estación Central de Taipéi: el gran vestíbulo de ladrillo rojo de 1941. Mira, hasta tiene el reloj.',
          xm_volunteer: 'Una postal del templo de Longshan. ¿Sabías que lo construyeron en 1738 colonos llegados de Fujian?',
          ck_guide: 'Una postal de la puerta blanca de la Plaza de la Libertad. ¡Sus cinco arcos miden 30 metros!',
        },
        ask: '¿Me daría una postal para mi abuela?',
        give: 'Darle a la abuela las tres postales',
        thanks: 'Ay… la estación, el templo, la gran puerta. Es como si hubiera viajado contigo. Gracias, cielo.',
      },
      pineapple: {
        offer: 'La abuela viene a merendar y le encantan los pasteles de piña 鳳梨酥. Los mejores están en Taipéi: ¿me traerías una caja si vas?',
        accept: '¡Traeré una caja de pasteles de piña!',
        buy: 'Comprar una caja de pasteles de piña (60🪙)',
        bought: '¡Recién salidos del horno! Masa de mantequilla y mermelada de piña dentro. Lleva la caja plana.',
        poor: 'La caja cuesta 60 monedas. ¡Vuelve cuando tengas bastante!',
        give: 'Darle a mamá los pasteles de piña',
        thanks: '¡Pasteles de piña de Taipéi de verdad! La abuela se va a poner contentísima. Eres una estrella.',
      },
      elephant: {
        offer: 'Todos en el cole tienen una foto del Taipéi 101 desde la Montaña del Elefante. ¿Me haces una? ¡Porfiii!',
        accept: '¡Subiré y haré la foto!',
        ask: '¿Me hace una foto con el Taipéi 101?',
        shot: '¡Patata! …Perfecta: todo el skyline detrás de ti. 600 escalones bien invertidos.',
        give: 'Enseñarle a Emma la foto desde la Montaña del Elefante',
        thanks: '¡HALA! ¡La ciudad entera! La pongo en la nevera. ¡Eres lo mejor!',
      },
      mochi: {
        offer: 'Mi primo dice que el mochi 麻糬 de Hualien es lo más blandito del mundo. Si vas por allí… ¿me traes? Te cambio mi mejor canica.',
        accept: 'Trato hecho. ¡Mochi de Hualien al canto!',
        buy: 'Comprar una caja de mochi para Bo (40🪙)',
        bought: 'Machacado esta mañana: judía mungo, sésamo y cacahuete. ¡Cómetelos hoy, que no aguantan!',
        poor: 'La caja cuesta 40 monedas, jovencito. ¡Ahorra y vuelve!',
        give: 'Darle a Bo el mochi de Hualien',
        thanks: '¡Qué BLANDITOS! Toma, la canica: es tuya. El mejor cambio de la historia.',
      },
      pebble: {
        offer: 'Colecciono piedras de todo Taiwán. Me falta un guijarro gris y redondo de la playa de Qixingtan, en Hualien. ¿Me encontrarías uno?',
        accept: 'Un guijarro de Qixingtan. ¡Lo encontraré!',
        ask: '¿Puedo llevarme un guijarro para la colección de una amiga?',
        found: '¿Uno? Vale, pero solo uno, y dile a tu amiga que la playa necesita el resto. El mar lo ha pulido durante mil años.',
        give: 'Darle a Rain el guijarro de Qixingtan',
        thanks: 'Redondo, gris, suave como el cristal… es perfecto. ¡Qixingtan, conseguido! ¡Gracias!',
      },
    },
  },
};
